<template>
  <div class="cartview">
    <div class="cartbar">
      <div class="cart" @click="showCart = true">
        <i class="fas fa-shopping-cart"></i>
        <div class="content">
          <h5>目前選購總金額</h5>
          <h2>NT {{ getTotal }} 元</h2>
        </div>
      </div>
      <div class="order" v-if="CartData && CartData.length !== 0">
        <router-link to="/order">立即結帳</router-link>
      </div>
    </div>

    <div class="cart_contents" :class="{ active: showCart }">
      <h2>
        <span @click="clearCart">全部清除</span>
        購物車 <i @click="showCart = false" class="fas fa-times-circle"></i
        ><br />
      </h2>
      <div class="cartArea">
        <ul>
          <li v-for="item in CartData" :key="item.product_id">
            <div class="left">
              <img
                :src="APIURL + 'images/items/' + item.product_image"
                alt=""
              />
              <div class="content">
                <h2>{{ item.product_names }}</h2>
                <h3>小計: NT {{ item.product_sellPrice * item.count }} 元</h3>
              </div>
            </div>
            <div class="info">
              <div class="count">
                <button @click="lessCart(item.product_id)">
                  <i class="fas fa-minus"></i>
                </button>
                <h6>{{ getCartItemCount(item.product_id) }}</h6>
                <button
                  @click="
                    addCart(
                      item.product_id,
                      item.product_names,
                      item.product_sellPrice,
                      item.product_Img
                    )
                  "
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </li>

          <li
            style="background: #efefef; display: flex"
            v-if="ExpireData && ExpireData.length > 0"
          >
            <h3>已失效商品</h3>
            <h4
              class="expireClean"
              @click="clearExpire"
            >
              全部清除
            </h4>
          </li>
          <li
            v-for="item in ExpireData"
            :key="item.product_id"
            style="background: #efefef"
          >
            <div class="left">
              <img
                :src="APIURL + 'images/items/' + item.product_image"
                alt=""
              />
              <div class="content">
                <h2>{{ item.product_names }}</h2>
              </div>
            </div>
          </li>
        </ul>
        <div
          class="nothing"
          v-if="
            !CartData ||
            (CartData.length == 0 && !(ExpireData && ExpireData.length > 0))
          "
        >
          <h2>購物車沒東西</h2>
          <button @click="showCart = false">
            <router-link to="/" style="text-decoration: none; color: white">
              立即採購</router-link
            >
          </button>
        </div>

        <router-link
          v-if="CartData && CartData.length !== 0"
          class="goOrder"
          to="/order"
          >結帳</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCart: false,
      APIURL: process.env.VUE_APP_APIURL,
      // CartData: [],
      isCommon: false,
      // newStorage: [],
    };
  },
  computed: {
    CartData() {
      return this.$store.state.CartData;
    },
    ExpireData() {
      return this.$store.state.expireProduct;
    },
    getTotal() {
      let total = 0;
      this.CartData.forEach((item) => {
        total += item.count * item.product_sellPrice;
      });
      return total;
    },
  },
  created() {
    // this.CartData = JSON.parse(localStorage.getItem('cartdata'));
    window.addEventListener('click', this.close);
  },
  beforeDestroy() {
    // window.removeEventListener('click', this.close);
  },
  methods: {
    // setshowCart() {
    //   this.showCart = false;
    // },
    // close(e) {
    //   if (!this.$el.contains(e.target)) {
    //     this.showCart = false;
    //   }
    // },
    getCartItemCount(id) {
      const vm = this;
      vm.hasProduct = false;
      vm.count = 0;
      this.CartData.forEach((item) => {
        if (item.product_id === id) {
          vm.hasProduct = true;
          vm.count = item.count;
        }
      });
      return vm.count;
    },
    addCart(id, names, sellPrice, image) {
      this.$store.dispatch('ADD_TO_CART', {
        product_id: id,
        product_names: names,
        product_sellPrice: sellPrice,
        product_image: image,
        count: 1,
      });
    },
    lessCart(id) {
      this.$store.dispatch('LESS_TO_CART', {
        product_id: id,
      });
    },
    clearCart() {
      const vm = this;
      localStorage.removeItem('cartdata');
      this.$store.commit('localStorageOverWrite', []);
      this.$store.commit('setexpireProduct', []);
      setTimeout(() => {
        vm.showCart = false;
      }, 200);
    },
    clearExpire() {
      const vm = this;
      const oldStorage = JSON.parse(
        JSON.stringify(JSON.parse(localStorage.getItem('cartdata'))),
      );
      const newStorage = [];
      for (let i = 0; i < oldStorage.length; i += 1) {
        vm.isCommon = false;
        for (let j = 0; j < this.ExpireData.length; j += 1) {
          if (oldStorage[i].product_id === vm.ExpireData[j].product_id) {
            vm.isCommon = true;
          }
        }
        if (!vm.isCommon) {
          newStorage.push(oldStorage[i]);
        }
      }
      localStorage.setItem('cartdata', JSON.stringify(newStorage));
      this.$store.commit('setexpireProduct', []);
    },
  },
};
</script>

<style>
</style>
